import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Check } from "lucide-react";
import { SERVICES } from "./data";
import { Container, MaskText, Reveal, Overline, LimeButton, ArrowDot, scrollToId, ease } from "./primitives";

export const Formats = () => {
  const [active, setActive] = useState(1);
  const s = SERVICES[active];
  return (
    <section className="relative bg-[#060B19] py-20 text-white lg:py-32" data-testid="formats-section">
      <Container className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-6">
          <Overline dark>Formatos</Overline>
          <MaskText className="font-display mt-6 text-3xl font-bold leading-[1.05] tracking-[-0.03em] sm:text-5xl"
            lines={["Identifique o formato", "ideal para o momento", <>da <span className="text-[#CCFF00]">sua empresa.</span></>]} />
          <div className="mt-12 border-t border-white/10">
            {SERVICES.map((x, i) => (
              <button key={x.t} onClick={() => setActive(i)} data-testid={`formatos-tab-trigger-${i}`}
                className="relative flex w-full items-center gap-5 border-b border-white/10 py-5 text-left">
                {active === i && <motion.span layoutId="fmt-bar" className="absolute inset-y-0 -left-3 w-1 rounded-full bg-[#CCFF00]" transition={{ duration: 0.5, ease }} />}
                <span className={`font-mono-x text-xs ${active === i ? "text-[#CCFF00]" : "text-slate-400"}`}>0{i + 1}</span>
                <span className={`text-base font-semibold transition-colors duration-300 sm:text-lg ${active === i ? "text-white" : "text-slate-400 hover:text-slate-200"}`}>{x.t}</span>
              </button>
            ))}
          </div>
        </div>
        <Reveal className="lg:col-span-6 lg:pl-8">
          <div className="relative min-h-[460px] overflow-hidden rounded-[28px] bg-[#1238CE] p-8 sm:p-10" data-testid="formatos-detail-card">
            <div className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-[#CCFF00]/20 blur-3xl" />
            <AnimatePresence initial={false}>
              <motion.div key={active} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -12, position: "absolute" }}
                transition={{ duration: 0.5, ease }} className="relative">
                <div className="font-mono-x text-xs uppercase tracking-[0.2em] text-[#CCFF00]">Formato 0{active + 1}</div>
                <h3 className="font-display mt-5 text-3xl font-bold leading-tight tracking-[-0.02em] sm:text-4xl">{s.t}</h3>
                <p className="mt-5 text-base leading-relaxed text-white/85">{s.d}</p>
                <ul className="mt-8 space-y-3">
                  {s.items.map((it) => (
                    <li key={it} className="flex items-center gap-3 text-sm font-medium">
                      <span className="grid h-6 w-6 place-items-center rounded-full bg-[#CCFF00] text-[#060B19]"><Check size={14} strokeWidth={3} /></span>{it}
                    </li>
                  ))}
                </ul>
                <LimeButton className="mt-10" onClick={() => scrollToId("contato")} data-testid="formatos-cta">Quero este formato <ArrowDot /></LimeButton>
              </motion.div>
            </AnimatePresence>
          </div>
        </Reveal>
      </Container>
    </section>
  );
};
